export default __webpack_public_path__ + "static/media/vitra_chair_10.57118744.jpg";